const installationData = [
  {
    id: 1,
    title: "Installation",
    subtitle: "Programming, installation and training",
    status: "Yes",
  }, {
    id: 2,
    title: "Fiber Broadband",
    subtitle: "Install 300 Mbps download and 300 Mbps upload fiber broadband",
    status: "Yes",
  }, {
    id: 3,
    title: "Data points installation",
    subtitle: "Cat5 / Data points installation for PCs, laptops and IP phones",
    status: "Yes",
  }, {
    id: 4,
    title: "New line installs",
    status: "Yes",
  }, {
    id: 5,
    title: "Wireless access points",
    status: "Yes",
  }, {
    id: 6,
    title: "Cloud key controller for Wi-Fi access points",
    status: "Yes",
  }, {
    id: 7,
    title: "Draytek 2952 Router",
    status: "Yes",
  }, {
    id: 8,
    title: "PoE Switch",
    status: "Yes",
  },
];
export default installationData;